import _isEmpty from "lodash/isEmpty";
import _isObject from "lodash/isObject";
var _excluded = ["subMenu"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { MobileMenuItem } from "../MobileMenuItem/MobileMenuItem";
import { Button } from "../../Button/Button/Button";
import styles from "./MobileMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileMenu = function MobileMenu(_ref) {
  var _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? [] : _ref$primary,
    _ref$secondary = _ref.secondary,
    secondary = _ref$secondary === void 0 ? false : _ref$secondary,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {} : _ref$cta,
    _ref$closeSubMenuLabe = _ref.closeSubMenuLabel,
    closeSubMenuLabel = _ref$closeSubMenuLabe === void 0 ? 'Click to close {{link}} submenu' : _ref$closeSubMenuLabe,
    _ref$openSubMenuLabel = _ref.openSubMenuLabel,
    openSubMenuLabel = _ref$openSubMenuLabel === void 0 ? 'Click to open {{link}} submenu' : _ref$openSubMenuLabel;
  var renderMobileMenu = function renderMobileMenu(menuItems) {
    return /*#__PURE__*/_jsx("ul", {
      className: styles.mobileMenu,
      children: menuItems && menuItems.map(function (menuItem, index) {
        var subMenu = menuItem.subMenu,
          restMenuItem = _objectWithoutProperties(menuItem, _excluded);
        var props = {
          subMenu: subMenu,
          menuItem: restMenuItem,
          closeSubMenuLabel: closeSubMenuLabel,
          openSubMenuLabel: openSubMenuLabel
        };
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MobileMenuItem, _objectSpread({}, props), index)
        }, index);
      })
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderMobileMenu(primary), secondary && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("hr", {
        className: styles.lineBreak
      }), _isObject(secondary) && renderMobileMenu(secondary)]
    }), !_isEmpty(cta) && /*#__PURE__*/_jsx(Button, {
      attributes: cta === null || cta === void 0 ? void 0 : cta.mobileAttributes,
      type: "primary",
      url: cta === null || cta === void 0 ? void 0 : cta.url,
      className: styles.cta,
      size: 'small',
      children: cta === null || cta === void 0 ? void 0 : cta.text
    })]
  });
};